import React from 'react';
import styles from './styles/DeleteModal.module.css';

const DeleteModal = ({ onConfirm, onCancel, type }) => {
    return (
        <div className={styles.modalOverlay}>
            <div className={styles.modalContent}>
                <h2 className={styles.modalTitle}>Are you sure?</h2>
                <p className={styles.modalDescription}>Do you really want to delete this {type}? This action cannot be undone.</p>
                
                <div className={styles.buttonGroup}>
                    <button onClick={onConfirm} className={`${styles.buttonBase} ${styles.yesButton}`}>
                        Yes
                    </button>
                    <button onClick={onCancel} className={`${styles.buttonBase} ${styles.noButton}`}>
                        No
                    </button>
                </div>
            </div>
        </div>
    );
};

export default DeleteModal;
